import { Product } from './product';

export class Cart {
    public createDate!: string;
    public id!: number;
    public isFeeShip!: number;
    public isFragileGoods!: number;
    public note!: string;
    public products!: Product[];
    public shopId!: string;
    public shopName!: string;
    public site!: string;
    public uId!: number;
    public amount!: number;
    public isLoading!: boolean;
    public isChoose!: boolean;
    public amountCN!: number;
    public totalAmount!: number;
    public totalAmountCN!: number;
    public feeBuyPro!: number;
    public feeBuyProCN!: number;
    public deposit!: number;
    public depositCN!: number;
    public shippingMethodID!: number;
}
